import React, {useState} from "react";
import Card from "@mui/material/Card";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import moment from "moment/moment";
import {useTranslation} from "react-i18next";

const getBrowserTimeZoneAbbr = (value) => {
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZoneName: "short",
        hour: "2-digit",
        minute: "2-digit",
    }).formatToParts(value ? new Date(value) : new Date());
    const shortName = parts.find((part) => part.type === "timeZoneName")?.value || "";
    return shortName.replace(/[^A-Za-z]/g, "").toUpperCase() || "LOCAL";
};

const formatLocalDateTime = (value) => (
    value ? `${moment(value).format("MMM D, YYYY HH:mm")} (${getBrowserTimeZoneAbbr(value)})` : "-"
);

const OperationInfo = ({info = {} , loading, title}) => {
    const [isOpen,setIsOpen] = useState(true)
    const {t} = useTranslation()
    return(<React.Fragment>
        <Card  sx={{minWidth: 250}}>
            <MDBox
                mx={1}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="light"
                borderRadius="lg"
                coloredShadow="light"
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}

            >
                <MDTypography variant="h6">
                    {title || t('Operation Records')}
                </MDTypography>
                <IconButton size={'small'} disabled={loading} onClick={()=>setIsOpen(!isOpen)}>
                    {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                </IconButton>
            </MDBox>
            <Collapse in={isOpen&& !loading} timeout={500}>
                <MDBox pt={1} pb={2} px={2}>
                    <Grid container xs={12} display="flex" p={0} m={0}>
                        <Grid item mb={1} xs={12} md={6} lg={3}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('Add User')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.addUser}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={3}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('Add Time')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {formatLocalDateTime(info?.addTime)}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={3}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('Edit User')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.editUser}
                                </MDTypography>
                            </MDBox>
                        </Grid>


                        <Grid item mb={1} xs={12} md={6} lg={3}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('Edit Time')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {formatLocalDateTime(info?.editTime)}
                                </MDTypography>
                            </MDBox>
                        </Grid>




                    </Grid>
                </MDBox>
            </Collapse>

        </Card>
    </React.Fragment>)
}

export default OperationInfo